<template>
        <v-row
          ><v-col
            v-for="(element, key) in this.getselectedradiobtn()"
            :key="element.variable"
            cols="4"
           
          >
            <Ctrlfinddecay
              v-on:child-method="updateParent"
              :title="key"
              :options="element"
              :optionsrecomend="
                element.filter(
                  (a) => a.TrigmaAI_Recommendation == 'Recommended'
                )
              "
            ></Ctrlfinddecay> </v-col></v-row>
</template>
<script>
import apifactory from "../api";
import Ctrlfinddecay from "./ctrfinddecay.vue";
export default {
  components: {
    Ctrlfinddecay,
  },
  props: {
    options: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ishavedata: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    itemlistgroup: [],
    itemlistforsave: [],
    itemlistforsaveinDb: null,
    itemlistsaveddecay: [],
  }),

  methods: {
    updateParent(value_from_child) {
      this.msg = value_from_child;
      this.itemlistforsave = this.options.filter(
        (a) => a.TrigmaAI_Recommendation == "Recommended"
      );
      this.itemlistforsaveinDb = [];

      let dataforsave = new Object();
      for (let index = 0; index < this.itemlistforsave.length; index++) {
        dataforsave[this.itemlistforsave[index].variable] =
          this.itemlistforsave[index].decayselectednew;
        //templist.push(dataforsave);
      }
      //alert("[" + JSON.stringify(dataforsave) + "]");
      //alert('from1');
      this.save_channel_decay(
        this.title,
        "[" + JSON.stringify(dataforsave) + "]"
      );
    },
    updateParentOnLoad() {
      this.itemlistforsave = [];
      this.itemlistforsave = this.options.filter(
        (a) => a.TrigmaAI_Recommendation == "Recommended"
      );
      this.itemlistforsaveinDb = [];

      let dataforsave = new Object();
      for (let index = 0; index < this.itemlistforsave.length; index++) {
        dataforsave[this.itemlistforsave[index].variable] =
          this.itemlistforsave[index].decayselectednew;
        //templist.push(dataforsave);
      }
      //alert("updateParentOnLoad" + "[" + JSON.stringify(dataforsave) + "]");
      //alert('from2');
      this.save_channel_decay(
        this.title,
        "[" + JSON.stringify(dataforsave) + "]"
      );
    },
    get_saveed_channel_decay() {
      // alert("call get_saveed_channel_decay");
      apifactory
        .call_getsaved_channel_decay()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.itemlistsaveddecay = res.data;
            //alert(this.itemlistsaveddecay.length);
            /*for (let index = 0; index < res.data.length; index++) {
              const element = res.data[index];
              alert(element);
            }*/
            //alert(JSON.stringify(this.itemlistsaveddecay));
           // alert(JSON.stringify( this.itemlistsaveddecay) );
            
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
    save_channel_decay(varregion, varparam) {
      //alert('call save_channel_decay from ctrlfind ');
      apifactory
        .callsave_channel_decay(varregion, varparam)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            // this.showmsghide=true;
            // this.listfind_decay=res.data;
            //alert( JSON.stringify(res.data));
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
    callfromchild(vardata) {
      alert(vardata);
    },
    filteredDataCount() {
      let icount = this.options.length;
      return icount;
    },
    getselectedradiobtn() {
      let result = [];
      //this.result =this.options;
      //result=this.options.filter(a=>a.variable == 'webinar');
      result = this.groupBy(this.options, "variable");
      return result;
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    getdisyinctitems(MYJSON, prop) {
      return MYJSON.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
  },
  mounted() {
   
    //this.updateParentOnLoad();
    this.get_saveed_channel_decay();
  },
  computed: {},
};
</script>
